module.exports = __webpack_public_path__ + "static/img/superintendent_discretion.9bdae442.png";